import { analytics } from 'libs';
import { Select } from 'components/common';
import Filter from './Filter';

const options = [
  { label: '25 Years', value: '25' },
  { label: '30 Years', value: '30' },
  { label: '35 Years', value: '35' },
  { label: '40 Years', value: '40' },
] as const;

interface AmortizationFilterProps {
  filters: { amortization?: number | string };
  onFilter: (update: { amortization?: string }) => void;
}

const AmortizationFilter = ({ filters, onFilter }: AmortizationFilterProps) => {
  const onChange = (option: { label?: string; value?: string } | null, action: string) => {
    if (action === 'clear') analytics.productSearch.filter({ amortization: 'cleared' });
    if (action === 'select-option') analytics.productSearch.filter({ amortization: option?.label });
    onFilter({ amortization: option?.value });
  };

  return (
    <Filter name="Maximum Amortization">
      <Select
        className="filter__select"
        clearValue={null}
        onChange={onChange}
        options={options}
        placeholder="Select amortization"
        selected={options.find((opt) => opt.value === filters.amortization)}
        testId="filter-amortization"
      />
    </Filter>
  );
};

export default AmortizationFilter;
